import { render, staticRenderFns } from "./tableBody.vue?vue&type=template&id=d86badee"
import script from "./tableBody.vue?vue&type=script&lang=js"
export * from "./tableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports